var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie-animation',{staticClass:"lottie-container",style:({
    'height': _vm.height
  }),attrs:{"animationData":require(("@/assets/lottie/" + _vm.fileName + ".json"))}})}
var staticRenderFns = []

export { render, staticRenderFns }